// extracted by mini-css-extract-plugin
export default {"section":"Fq-z","sectionTitle":"Gq-z","fieldWrapper":"Hq-z","formField":"Iq-z","disabled":"Jq-z","formLabel":"Kq-z"};